import { NgModule } from "@angular/core";
import { ReservationSearchBarComponent } from "./reservation-search-bar.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";

@NgModule({
  declarations: [ReservationSearchBarComponent],
  exports: [ReservationSearchBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    WsTooltipModule,
    WsUiModule
  ]
})
export class ReservationSearchBarModule { }